import { Goal, ID, Timestamp } from '@griply/types';

export type ShouldArchiveWithParentOptions = {
  parentGoalId?: ID | null;
  goalArchivedAt?: Timestamp | null;
  allGoals: Goal[];
};

// Archived is inherited, so an active child under an archived parent is unreachable.
export const shouldArchiveWithParent = ({
  parentGoalId,
  goalArchivedAt,
  allGoals,
}: ShouldArchiveWithParentOptions): boolean => {
  if (!parentGoalId || goalArchivedAt) {
    return false;
  }

  return !!allGoals.find(({ id }) => id === parentGoalId)?.archivedAt;
};
